import {z} from 'zod';

export const autoScout24CredentialsSchema = z.object({
  username: z.string().min(1),
  password: z.string().min(1),
  customerId: z.string().min(1),
  testMode: z.boolean().optional(),
});

export type AutoScout24Credentials = z.infer<typeof autoScout24CredentialsSchema>;
